export default __webpack_public_path__ + "static/media/icon-call-active.867eabe7.svg";